import Head from 'next/head'

import type { FC, ReactNode } from 'react'
import type { SeoProps } from '@/types'

import { siteConfig } from '@/constants/site'

export const Seo: FC<SeoProps> = ({
    title,
    description = siteConfig.description,
    ogImage = siteConfig.ogImage,
    path = '/',
    noIndex = false
}): ReactNode => {
    const pageTitle = title ? `${title} - ${siteConfig.name}` : siteConfig.name
    const url = `${siteConfig.url}${path}`

    return (
        <Head>
            <title>
                {pageTitle}
            </title>

            <meta name='description' content={description} />
            <link rel='canonical' href={url} />
            {noIndex && <meta name='robots' content='noindex' />}

            <meta property='og:title' content={pageTitle} />
            <meta property='og:description' content={description} />
            <meta property='og:type' content='website' />
            <meta property='og:url' content={url} />
            <meta property='og:site_name' content={siteConfig.name} />
            <meta property='og:locale' content={siteConfig.locale} />
            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:title' content={pageTitle} />
            <meta name='twitter:description' content={description} />

            {ogImage && <meta property='og:image' content={ogImage} />}
            {ogImage && <meta property='og:image:width' content='1200' />}
            {ogImage && <meta property='og:image:height' content='630' />}
            {ogImage && <meta property='og:image:alt' content='Gashi Holding: Aufbauen. Skalieren. Verbinden.' />}
            {ogImage && <meta name='twitter:image' content={ogImage} />}
        </Head>
    )
}
